import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import axios from 'axios';
import { BASE_API_URL } from '../../utils/constants';
import { myFirebaseAuth } from '../../firebase/config';
import { logoutUser } from './authService';
import { DisputeRoutingRuleCreate, DisputeRoutingRuleUpdate } from '@dill/dill-shared';

export const getSupplierDisputeRoutingRules = createAsyncThunk(
  'disputeRoutingRules/getSupplierDisputeRoutingRules',
  async ({ supplierId }: { supplierId: string }, thunkApi) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }
      const response = await axios.get<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/disputeRoutingRules`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const createDisputeRoutingRule = createAsyncThunk(
  'disputeRoutingRules/createDisputeRoutingRule',
  async (
    { supplierId, data }: { supplierId: string; data: DisputeRoutingRuleCreate },
    thunkApi
  ) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }
      const response = await axios.post<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/disputeRoutingRules`,
        data,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.response?.data ?? error.message);
    }
  }
);

export const updateDisputeRoutingRule = createAsyncThunk(
  'disputeRoutingRules/updateDisputeRoutingRule',
  async (
    {
      supplierId,
      ruleId,
      data,
    }: { supplierId: string; ruleId: string; data: DisputeRoutingRuleUpdate },
    thunkApi
  ) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }
      const response = await axios.put<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/disputeRoutingRules/${ruleId}`,
        data,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.response?.data ?? error.message);
    }
  }
);

export const deleteDisputeRoutingRule = createAsyncThunk(
  'disputeRoutingRules/deleteDisputeRoutingRule',
  async ({ supplierId, ruleId }: { supplierId: string; ruleId: string }, thunkApi) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }
      const response = await axios.delete<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/disputeRoutingRules/${ruleId}`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.response?.data ?? error.message);
    }
  }
);
